import React from "react";
import { useTranslation } from "react-i18next";

import { ErrorReason } from "@/types/Flashscan";
import "./FlashscanAnomaliesFilters.scss";

export type FlashscanAnomaliesFilterValue = "ALL" | ErrorReason;

type FlashscanAnomaliesFiltersProps = {
  value: FlashscanAnomaliesFilterValue;
  onChange: (next: FlashscanAnomaliesFilterValue) => void;
  availableReasons: ErrorReason[];
};

export const FlashscanAnomaliesFilters: React.FC<
  FlashscanAnomaliesFiltersProps
> = ({ value, onChange, availableReasons }) => {
  const { t } = useTranslation();

  const filters: FlashscanAnomaliesFilterValue[] = [
    "ALL",
    ...availableReasons,
  ];

  return (
    <div className="flashscan-anomalies-filters">
      {filters.map((filter) => (
        <button
          key={filter}
          type="button"
          className={`flashscan-anomalies-filters-btn ${
            value === filter ? "flashscan-anomalies-filters-btn--active" : ""
          }`}
          onClick={() => onChange(filter)}
        >
          {filter === "ALL"
            ? t("pages.flashscan.anomalies.filters.all")
            : t(`pages.flashscan.rules.${filter}`)}
        </button>
      ))}
    </div>
  );
};

